import { render, staticRenderFns } from "./PriceDataForm.vue?vue&type=template&id=b7934a7a"
import script from "./PriceDataForm.vue?vue&type=script&lang=js"
export * from "./PriceDataForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports